/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, DAKSH_SCREEN, COMMON } from '../../global/Constants';
import { DakshSaleType, DakshStatus, CROP_GROUP } from '../../global/Enum';
import DesktopFooter from '../common/DesktopFooter';
import Header from '../common/Header';
import Footer from '../common/Footer';
import './daksh.css';
import DakshHeader from './components/DakshHeader';
import ViewQuantity from './components/ViewQuantity';
import ViewQuantityData from './components/ViewQuantityData';
import Utilities from '../../global/Utilities';
import TitleStatus from './components/TitleStatus';
import ApiServices from '../../providers/ApiServices';
import Loader from '../common/loader/Loader';
import { toast } from 'react-toastify';
import DataProvider from '../../providers/DataProvider';
import SyncLoader from '../common/loader/SyncLoader';

class ViewSalePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saleType: DakshSaleType.NONE,
            saleData: null,
            moduleType: 1,
            status: DakshStatus.COMPLETED,
            isSubmitVisible: false,

            // stars: [
            //     { crop: "Rice", star: 5 },
            //     { crop: "Cotton", star: 2 }
            // ]
        }
    }

    componentDidMount() {
        if (Utilities.checkLogin()) {
            const data = this.props.location.state;
            if (data) {
                Utilities.LogPrint("Krunal", data);

                //const retailer = Utilities.getRetailer();
                //Utilities.LogPrint("retailer ======", retailer);

                this.setState({
                    saleType: data.saleType,
                    saleData: data.saleData,
                    status: data.saleData.saleStatus,
                    isSubmitVisible: data?.isSubmitVisible ? true : false
                });
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    checkVegCrops = () => {
        const cropGroups = DataProvider.getInstance().getCropGroups();
        Utilities.LogPrint("CropGroups", cropGroups);
        if (cropGroups.length > 0) {
            Utilities.LogPrint("CropGroups In Menu", cropGroups?.some(item => item.crop_group_id === CROP_GROUP.VEGETABLE_CROPS));
            return cropGroups?.some(item => item.crop_group_id === CROP_GROUP.VEGETABLE_CROPS);
        } else {
            return false;
        }
    }

    clickHandler = (type) => {
        const { saleData, moduleType } = this.state;

        switch (type) {
            case DakshSaleType.SEEDWORKS_SALE:
                //this.setState({ saleType: DakshSaleType.SEEDWORKS_SALE })
                if (saleData.total_seedworks > 0) {
                    this.setState({ saleType: DakshSaleType.SEEDWORKS_SALE });
                } else {
                    if (this.checkVegCrops()) {
                        this.props.history.push({
                            pathname: ALL_ROUTES.ADD_SEEDWORKS_SALE,
                            state: { data: saleData, moduleType: moduleType }
                        });
                    }
                }
                break;
            case DakshSaleType.COMPETITOR_SALE:
                //this.setState({ saleType: DakshSaleType.COMPETITOR_SALE })
                if (saleData.total_competitor > 0) {
                    this.setState({ saleType: DakshSaleType.COMPETITOR_SALE });

                } else {
                    this.props.history.push({
                        pathname: ALL_ROUTES.ADD_COMPETITOR_SALE,
                        state: { data: saleData, moduleType: moduleType }
                    });
                }
                break;
            default:
                break;
        }
    }

    handleEdit = () => {
        const { saleData, moduleType } = this.state;
        //this.props.history.push(ALL_ROUTES.ADD_SALE_ROUTE);

        this.props.history.push({
            pathname: ALL_ROUTES.ADD_COMPETITOR_SALE,
            state: { data: saleData, moduleType: moduleType }
        });
    }

    handleSubmitButton = () => {
        const { saleData, moduleType } = this.state;
        Utilities.LogPrint("Data", saleData);

        let mode_data = [];
        if (saleData?.seedworks !== null && saleData?.seedworks?.length > 0) {
            for (const element of saleData?.seedworks) {
                if (!element?.daksh_details_id) {
                    let obj = {
                        crop_id: element.crop_id,
                        hybrid_id: element.hybrid_id,
                        quantity: element.quantity,
                        weight_unit_id: element.weight_unit_id,
                        mode: 1
                    }
                    mode_data.push(obj);
                }
            }
        }

        if (saleData.competitors !== null) {
            for (const element of saleData.competitors) {
                let obj = {
                    crop_id: element.crop_id,
                    hybrid_id: element.hybrid_id,
                    quantity: element.quantity,
                    weight_unit_id: element.weight_unit_id,
                    mode: 2
                }
                mode_data.push(obj);
            }
        }
        Utilities.LogPrint("Mode Data", mode_data);

        const retailer = Utilities.getRetailer();
        let request = JSON.stringify({
            module_type: moduleType,
            retailer_id: retailer?.value,
            year: new Date().getFullYear(),
            mode_data: mode_data
        })
        Utilities.LogPrint("Request", request);
        this.setState({ isLoading: true });

        try {
            ApiServices.addDakshData(request)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        toast.success(response.message);
                        this.props.history.replace(ALL_ROUTES.DAKSH_ROUTE);

                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false, errorMsg: error });
        }
    }

    handleCancelButton = () => {
        //this.props.history.goBack();
        this.props.history.replace(ALL_ROUTES.DAKSH_ROUTE);
    }

    isEdit = () => {
        const { saleData } = this.state;
        return saleData.saleStatus === DakshStatus.TO_START ? true : false;
    }

    setRating = (star) => {
        if (star >= 15) {
            return (
                // <div className="yellow-star checked"></div>
                <div><i className="customic super-star yellow-star"></i></div>
            )
        } else if (star > 0) {
            const stars = Array.from(Array(parseInt(star)).keys());
            return (
                stars.map((item, i) => (
                    <div key={i} className="clip-star checked"></div>
                ))
            )
        } else {
            return (
                <div className="zero-star">0</div>
            )
        }
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName);
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isLoading, status, saleType, saleData, isSubmitVisible } = this.state;
        const { isSyncLoading, tableName } = this.state;
        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />
                <Footer />

                <div className="container pt-35 daksh">
                    <DakshHeader />

                    <div className="row">
                        {/* Sale Table */}
                        <div className="col-12 sale-table">
                            <TitleStatus
                                title={DAKSH_SCREEN.SALE}
                                status={status}
                            />
                            {/* <h5 className="font mt-0">Sale <i className="customic ic-sale-green"></i>
                                <i class="customic ic-sale-yellow"></i>
                                <i class="customic ic-sale-red"></i>
                            </h5> */}

                            {/* Sale Table */}
                            <ViewQuantity
                                data={saleData}
                                clickHandler={this.clickHandler} />
                        </div>

                        {/* Sale Quantity Data*/}
                        {saleType === DakshSaleType.SEEDWORKS_SALE && saleData?.total_seedworks > 0 ?
                            <ViewQuantityData
                                data={saleData?.seedworks}
                                title={DAKSH_SCREEN.SEEDWORKS_SALE}
                                isEdit={false}
                            /> : null
                        }

                        {saleType === DakshSaleType.COMPETITOR_SALE && saleData?.total_competitor > 0 ?
                            <ViewQuantityData
                                data={saleData?.competitors}
                                title={DAKSH_SCREEN.COMPETITOR_SALE}
                                isEdit={this.isEdit()}
                                handleEdit={this.handleEdit}
                            /> : null
                        }

                        {/* Seedworks Sale Details */}
                        {
                            saleType === DakshSaleType.SEEDWORKS_SALE && saleData?.total_seedworks > 0 ?
                                <div className="col-12 col-md-12 col-lg-8 mt-40">
                                    <div className="row mb-3 mb-md-5">
                                        <div className="col-8 col-sm-7 col-md-6 col-lg-6">
                                            <label className="font-weight-medium mt-2">{DAKSH_SCREEN.US_AGRISTAR_POINTS}</label>
                                        </div>
                                        <div className="col-4 col-sm-5 col-md-6 col-lg-6">
                                            <div className="form-group mb-0">
                                                <input type="text" className="form-control text-center" placeholder="eg. 550" value={saleData?.points} readOnly />
                                            </div>
                                        </div>
                                    </div>

                                    {saleData.star?.map((item, i) => (
                                        <div className="row mb-3 mb-md-5" key={i}>
                                            <div className="col-8 col-sm-7 col-md-6 col-lg-6">
                                                <label className="font-weight-medium mt-2">{item?.crop_name} - Star Category</label>
                                            </div>
                                            <div className="col-4 col-sm-5 col-md-6 col-lg-6">
                                                <div className="rating star">
                                                    {this.setRating(item?.star)}

                                                    {/* {this.setRating(saleData?.star)} */}

                                                    {/* <div className="clip-star checked"></div>
                                                    <div className="clip-star checked"></div>
                                                    <div className="clip-star checked"></div>
                                                    <div className="clip-star checked"></div>
                                                    <div className="clip-star"></div> */}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div> : null
                        }

                        {isSubmitVisible ?
                            <div className="col-12 mt-4 mb-4 btn-group-w">
                                <button className="btn btn-primary w-182" onClick={this.handleSubmitButton}>{COMMON.SUBMIT}</button>
                                <button className="btn btn-secondary ml-3 w-182" onClick={this.handleCancelButton}>{COMMON.CANCEL}</button>
                            </div> : null
                        }

                    </div>
                </div>
                <DesktopFooter />
                {isLoading ? <Loader /> : null}
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
            </div>

        )
    }
}

export default withRouter(ViewSalePage);